// Configuration file for environment variables
export const config = {
  apiServer: import.meta.env.VITE_API_SERVER || 'http://localhost:3000',
  socketServer: import.meta.env.VITE_SOCKET_SERVER || 'ws://localhost:3000',
  /**
   * Base URL for files uploaded to chatbot_server (persona avatars, etc.).
   * Channel persona rows store relative paths like `personas/abc.jpg`; we
   * prepend this for rendering. Backend prepends the same value before
   * sending `profile_picture_url` to Meta — keep the two in sync per env.
   */
  uploadsBase: import.meta.env.VITE_CHATBOT_UPLOADS_BASE || 'https://chatbot.mn/uploads',
  /** chatbot-analytics reports API (Audience reports). Same service in dev: it holds the real data. */
  analyticsServer: import.meta.env.VITE_ANALYTICS_SERVER || 'https://analytics.chatbot.mn',
} as const;

// Export individual variables for convenience
export const VITE_API_SERVER = import.meta.env.VITE_API_SERVER;
export const VITE_SOCKET_SERVER = import.meta.env.VITE_SOCKET_SERVER;

/**
 * Feature flags for UI components
 */
export const FEATURE_FLAGS = {
  /**
   * Message list rendering mode
   * - 'regular': Standard rendering (good for < 100 messages)
   * - 'virtualized': Virtual scrolling (better for 100+ messages)
   * 
   * Set via environment variable: VITE_USE_VIRTUALIZED_MESSAGES=true
   */
  USE_VIRTUALIZED_MESSAGES: import.meta.env.VITE_USE_VIRTUALIZED_MESSAGES === 'true' || false,
  
  /**
   * Threshold for switching to virtualized rendering automatically
   * If message count exceeds this, virtualized rendering is used (if enabled)
   */
  VIRTUALIZED_MESSAGES_THRESHOLD: 100,
  
  /**
   * Use ScrollContainer component instead of inline implementation
   * 
   * When enabled, ConversationView will use the ScrollContainer component
   * to encapsulate scroll logic. This improves code organization but
   * maintains the same functionality.
   * 
   * Set via environment variable: VITE_USE_SCROLL_CONTAINER=true
   */
  USE_SCROLL_CONTAINER: import.meta.env.VITE_USE_SCROLL_CONTAINER === 'true' || false,
} as const;

